import type {
  IMobileStoreRankPlatform,
  IMobileStoreRankSource,
  IMobileStoreRankTop,
  IStoreRankMoreTableDimensionInfos,
} from '@/pages/intelligence/types/storeRank';

export const MOBILE_PLATFORMS_NAMES_MAPPING: {
  [key in IMobileStoreRankPlatform]: string;
} = {
  appstore: 'App Store',
  googleplay: 'Google Play',
};

export const MOBILE_STORE_RANK_TOPS_NAMES_MAPPING: {
  [key in IMobileStoreRankTop]: string;
} = {
  'top paid': 'dbi_store_rank_top_paid',
  'top free': 'dbi_store_rank_top_free',
  'top grossing': 'dbi_store_rank_top_grossing',
  'top popular': 'dbi_store_rank_top_popular',
  'top new free': 'dbi_store_rank_top_new_free',
  'top new paid': 'dbi_store_rank_top_new_paid',
  'douyin_popularity': 'dbi_top_rank_douyin_popularity',
  'douyin_bestseller': 'dbi_top_rank_douyin_bestseller',
  'douyin_fresh_game': 'dbi_top_rank_douyin_fresh_game',
};

export const MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING: {
  [key in any]: string;
} = {
  'wechat_popularity': 'dbi_top_rank_wechat_popularity',
  'wechat_bestseller': 'dbi_top_rank_wechat_bestseller',
  'wechat_most_played': 'dbi_top_rank_wechat_most_played',
  'wechat_popularity_30d_avg': 'dbi_top_rank_wechat_popularity_30d_avg',
  'wechat_bestseller_30d_avg': 'dbi_top_rank_wechat_bestseller_30d_avg',
  'wechat_most_played_30d_avg': 'dbi_top_rank_wechat_most_played_30d_avg',
  'douyin_popularity': 'dbi_top_rank_douyin_popularity',
  'douyin_bestseller': 'dbi_top_rank_douyin_bestseller',
  'douyin_fresh_game': 'dbi_top_rank_douyin_fresh_game',
  'douyin_popularity_30d_avg': 'dbi_top_rank_douyin_popularity_30d_avg',
  'douyin_bestseller_30d_avg': 'dbi_top_rank_douyin_bestseller_30d_avg',
  'douyin_fresh_game_30d_avg': 'dbi_top_rank_douyin_fresh_game_30d_avg',
};

export const MOBILE_SOURCE_APPSTORE_TOP_FREE: IMobileStoreRankTop = 'appstore top free';

export const MOBILE_SOURCES: IMobileStoreRankTop[] = [
  MOBILE_SOURCE_APPSTORE_TOP_FREE,
  'appstore top grossing',
  'appstore top paid',
  'googleplay top free',
  'googleplay top grossing',
  'googleplay top paid',
  'googleplay top popular',
];

export const MOBILE_SOURCES_METRICS_KEYS = [
  'appstore top free|rank',
  'appstore top grossing|rank',
  'appstore top paid|rank',
  'googleplay top free|rank',
  'googleplay top grossing|rank',
  'googleplay top paid|rank',
  'googleplay top popular|rank',
];

export const DOUYIN_SOURCES: any[] = [
  'douyin_popularity',
  'douyin_bestseller',
  'douyin_fresh_game',
];

export const WECHAT_SOURCES_METRICS_KEYS = [
  'wechat_popularity|game_rank',
  'wechat_popularity|avg_rank_30d',
  'wechat_bestseller|game_rank',
  'wechat_bestseller|avg_rank_30d',
  'wechat_most_played|game_rank',
  'wechat_most_played|avg_rank_30d',
  'douyin_popularity|game_rank',
  'douyin_popularity|avg_rank_30d',
  'douyin_bestseller|game_rank',
  'douyin_bestseller|avg_rank_30d',
  'douyin_fresh_game|game_rank',
  'douyin_fresh_game|avg_rank_30d',
];

export const WECHAT_PLATFORM_TOP_INFOS: {
  [key: string]: IStoreRankMoreTableDimensionInfos;
} = {
  'wechat_popularity|game_rank': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'weixin',
    top: 'wechat_popularity',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['wechat_popularity'],
    titleContent: 'dbi_wechat_popularity_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'wechat_popularity|avg_rank_30d': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'weixin',
    top: 'wechat_popularity_30d_avg',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['wechat_popularity_30d_avg'],
    titleContent: 'dbi_wechat_popularity_30d_avg_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'wechat_bestseller|game_rank': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'weixin',
    top: 'wechat_bestseller',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['wechat_bestseller'],
    titleContent: 'dbi_wechat_bestseller_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'wechat_bestseller|avg_rank_30d': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'weixin',
    top: 'wechat_bestseller_30d_avg',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['wechat_bestseller_30d_avg'],
    titleContent: 'dbi_wechat_bestseller_30d_avg_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'wechat_most_played|game_rank': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'weixin',
    top: 'wechat_most_played',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['wechat_most_played'],
    titleContent: 'dbi_wechat_most_played_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'wechat_most_played|avg_rank_30d': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'weixin',
    top: 'wechat_most_played_30d_avg',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['wechat_most_played_30d_avg'],
    titleContent: 'dbi_wechat_most_played_30d_avg_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'douyin_popularity|game_rank': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'douyin',
    top: 'douyin_popularity',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['douyin_popularity'],
    titleContent: 'dbi_douyin_popularity_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'douyin_popularity|avg_rank_30d': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'douyin',
    top: 'douyin_popularity_30d_avg',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['douyin_popularity_30d_avg'],
    titleContent: 'dbi_douyin_popularity_30d_avg_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'douyin_bestseller|game_rank': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'douyin',
    top: 'douyin_bestseller',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['douyin_bestseller'],
    titleContent: 'dbi_douyin_bestseller_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'douyin_bestseller|avg_rank_30d': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'douyin',
    top: 'douyin_bestseller_30d_avg',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['douyin_bestseller_30d_avg'],
    titleContent: 'dbi_douyin_bestseller_30d_avg_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'douyin_fresh_game|game_rank': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'douyin',
    top: 'douyin_fresh_game',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['douyin_fresh_game'],
    titleContent: 'dbi_douyin_fresh_game_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'douyin_fresh_game|avg_rank_30d': {
    rendererType: 'WeiXinTableShowDataRenderer',
    platform: 'douyin',
    top: 'douyin_fresh_game_30d_avg',
    title: MINIGAME_STORE_RANK_TOPS_NAMES_MAPPING['douyin_fresh_game_30d_avg'],
    titleContent: 'dbi_douyin_fresh_game_30d_avg_more_title_tips',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
};

export const MOBILE_PLATFORM_TOP_INFOS: {
  [key: string]: IStoreRankMoreTableDimensionInfos;
} = {
  'appstore top free|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'appstore',
    top: 'top free',
    title: MOBILE_STORE_RANK_TOPS_NAMES_MAPPING['top free'],
    titleContent: 'dbi_store_rank_mobile_top_title_tips1',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'appstore top grossing|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'appstore',
    top: 'top grossing',
    title: MOBILE_STORE_RANK_TOPS_NAMES_MAPPING['top grossing'],
    titleContent: 'dbi_store_rank_mobile_top_title_tips2',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'appstore top paid|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'appstore',
    top: 'top paid',
    title: MOBILE_STORE_RANK_TOPS_NAMES_MAPPING['top paid'],
    titleContent: 'dbi_store_rank_mobile_top_title_tips3',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'googleplay top free|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'googleplay',
    top: 'top free',
    title: MOBILE_STORE_RANK_TOPS_NAMES_MAPPING['top free'],
    titleContent: 'dbi_store_rank_mobile_top_title_tips4',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'googleplay top grossing|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'googleplay',
    top: 'top grossing',
    title: MOBILE_STORE_RANK_TOPS_NAMES_MAPPING['top grossing'],
    titleContent: 'dbi_store_rank_mobile_top_title_tips5',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'googleplay top paid|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'googleplay',
    top: 'top paid',
    title: MOBILE_STORE_RANK_TOPS_NAMES_MAPPING['top paid'],
    titleContent: 'dbi_store_rank_mobile_top_title_tips6',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  'googleplay top popular|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: 'googleplay',
    top: 'top popular',
    title: MOBILE_STORE_RANK_TOPS_NAMES_MAPPING['top popular'],
    titleInfo: '',
    titleContent: '',
    ratioShow: true,
    ratioSortable: false,
  },
};

export const MOBILE_SECTIONAL_RANK_KEYS = ['1-3', '1-10', '1-50', '1-200'];

export const MOBILE_SECTIONAL_RANK_INFOS: {
  [key: string]: IStoreRankMoreTableDimensionInfos;
} = {
  '1-3': {
    rendererType: 'TableShowDataRenderer',
    platform: '',
    top: '',
    title: '1-3',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  '1-10': {
    rendererType: 'TableShowDataRenderer',
    platform: '',
    top: '',
    title: '1-10',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  '1-50': {
    rendererType: 'TableShowDataRenderer',
    platform: '',
    top: '',
    title: '1-50',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
  '1-200': {
    rendererType: 'TableShowDataRenderer',
    platform: '',
    top: '',
    title: '1-200',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: false,
  },
};

// mobile榜单下钻页 页面打点配置
export const MOBILE_PAGE_LOG_CFG_KEYS: { [key: string]: string } = {
  'appstore top free': 'mobileStoreRankMoreAppstoreTopFree',
  'appstore top grossing': 'mobileStoreRankMoreAppstoreTopGrossing',
  'appstore top paid': 'mobileStoreRankMoreAppstoreTopPaid',
  'googleplay top free': 'mobileStoreRankMoreGoogleplayTopFree',
  'googleplay top grossing': 'mobileStoreRankMoreGoogleplayTopGrossing',
  'googleplay top paid': 'mobileStoreRankMoreGoogleplayTopPaid',
  'googleplay top popular': 'mobileStoreRankMoreGoogleplayTopPopular',
  'googleplay top new free': 'mobileStoreRankMoreGoogleplayTopNewFree',
  'googleplay top new paid': 'mobileStoreRankMoreGoogleplayTopNewPaid',
};

export const MINIGAME_PAGE_LOG_CFG_KEYS: { [key: string]: string } = {
  'wechat_popularity': 'minigameStoreRankMoreWechatPopularity',
  'wechat_bestseller': 'minigameStoreRankMoreWechatBestsellery',
  'wechat_most_played': 'minigameStoreRankMoreWechatMostPlayed',
  'douyin_popularity': 'minigameStoreRankMoreDouyinPopularity',
  'douyin_bestseller': 'minigameStoreRankMoreDouyinBestsellery',
  'douyin_fresh_game': 'minigameStoreRankMoreDouyinMostPlayed',
};

export const MOBILE_SORT_TOPS_KEYS: {
  [key: string]: IMobileStoreRankSource[];
} = {
  daily_appstore: ['appstore top free', 'appstore top grossing', 'appstore top paid'],
  daily_googleplay: [
    'googleplay top free',
    'googleplay top grossing',
    'googleplay top paid',
    'googleplay top popular',
    // 'googleplay top new free',
    // 'googleplay top new paid',
  ],
};

// storerank-免费榜单
export const MOBILE_SORT_FREE_TOPS_KEYS: string[] = [
  'appstore top free',
  'appstore top grossing',
  'googleplay top free',
  'googleplay top grossing',
  'googleplay top popular',
];

// storerank-付费榜单
export const MOBILE_SORT_PAID_TOPS_KEYS: string[] = [
  'appstore top paid',
  'appstore top grossing',
  'googleplay top paid',
  'googleplay top grossing',
  'googleplay top popular',
];

// storerank-免费榜单segment
export const MOBILE_SORT_FREE_TOPS_SEGMENT: any[] = [
  {
    value: 'appstore top free',
    textKey: 'dbi_store_rank_top_free',
  },
  {
    value: 'appstore top grossing',
    textKey: 'dbi_store_rank_top_grossing',
  },
  {
    value: 'googleplay top free',
    textKey: 'dbi_store_rank_top_free',
  },
  {
    value: 'googleplay top grossing',
    textKey: 'dbi_store_rank_top_grossing',
  },
  {
    value: 'googleplay top popular',
    textKey: 'dbi_store_rank_top_popular',
  },
];

// storerank-付费榜单segment
export const MOBILE_SORT_PAID_TOPS_SEGMENT: any[] = [
  {
    value: 'appstore top paid',
    textKey: 'dbi_store_rank_top_paid',
  },
  {
    value: 'appstore top grossing',
    textKey: 'dbi_store_rank_top_grossing',
  },
  {
    value: 'googleplay top paid',
    textKey: 'dbi_store_rank_top_paid',
  },
  {
    value: 'googleplay top grossing',
    textKey: 'dbi_store_rank_top_grossing',
  },
  {
    value: 'googleplay top popular',
    textKey: 'dbi_store_rank_top_popular',
  },
];
